import { Link } from 'react-router'
import { Group, Text, UnstyledButton } from '@mantine/core'
import classes from './StatPill.module.css'

// A single "big number + dim label" pill from a stat strip. Clickable either as
// a router Link (`to`) — e.g. the dashboard pipeline navigating to a filtered
// page — or as an in-place action (`onClick`) — e.g. the distributions stats
// setting the status filter. The number reads `color` when non-zero, dimmed at
// zero so empty buckets recede.
type StatPillBase = {
    value: number
    label: string
    color: string
}

// Exactly one of `to` (router Link) or `onClick` (in-place action) is required —
// a discriminated union so neither-omitted (a no-op pill) and both-provided
// (onClick silently ignored) are compile-time errors.
export type StatPillProps = StatPillBase &
    ({ to: string; onClick?: never } | { onClick: () => void; to?: never })

export function StatPill({ value, label, color, to, onClick }: StatPillProps) {
    const content = (
        <Group gap={8} wrap='nowrap' align='baseline'>
            <Text fw={700} fz='xl' c={value > 0 ? color : 'dimmed'}>
                {value}
            </Text>
            <Text size='sm' c='dimmed'>
                {label}
            </Text>
        </Group>
    )

    if (to) {
        return (
            <UnstyledButton component={Link} to={to} className={classes.pill}>
                {content}
            </UnstyledButton>
        )
    }
    return (
        <UnstyledButton onClick={onClick} className={classes.pill}>
            {content}
        </UnstyledButton>
    )
}
